// extracted by mini-css-extract-plugin
export default {"similar":"SummarySimilarCars__similar--H2XI1","car":"SummarySimilarCars__car--QX1Sm","image":"SummarySimilarCars__image--dznO7"};